<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #Tareas
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12, md12, sm12)
        v-card(color='', style="border-radius:5px;background-color: white;")
          v-card-title(style='padding: 8px !important;').justify-center
            img(src='../assets/logo.png', style='height: auto;width: 80px;border-radius:5px')
        v-card(color='', style="border-radius:5px;background-color: black")
          v-card-title(style="padding: 7px;").justify-center
            span.white--text Administración de Tareas

    v-card(style="border-radius:5px;margin-top:10px;background-color:white;")
      v-card-text
        v-layout(row wrap)
          v-flex(xs12 sm3 style='padding: 6px')
            v-select(
              outline
              :items="vendedoresItems"
              v-model="filtroVen"
              label="Vendedor"
              clearable
              @change="onVendedorChange"
            )
          v-flex(xs12 sm3 style='padding: 6px')
            v-select(
              outline
              :items="clientesItems"
              v-model="filtroCli"
              label="Cliente"
              clearable
              :disabled="!filtroVen"
              :hint="!filtroVen ? 'Selecciona un vendedor primero' : ''"
              persistent-hint
            )
          v-flex(xs12 sm3 style='padding: 6px')
            v-select(
              outline
              :items="estatusItems"
              v-model="filtroEstatus"
              label="Estatus"
              clearable
            )
          v-flex(xs12 sm3 style='padding: 6px; display:flex; align-items:center;')
            v-text-field(
              outline
              v-model="busqueda"
              label="Buscar tarea"
              prepend-inner-icon="search"
              clearable
            )

    v-card(style="border-radius:5px;margin-top:10px;background-color:white;" v-if="loading")
      v-card-text(style="text-align:center;padding:40px;")
        v-progress-circular(indeterminate color="black" size="48")

    div(v-if="!loading")
      div(v-if="tareasFiltradas.length === 0" style="text-align:center;padding:40px;color:#9E9E9E;font-size:15px;")
        | No hay tareas para mostrar.

      v-card(
        v-for="(t, i) in tareasFiltradas"
        :key="i"
        style="border-radius:5px;margin-top:10px;background-color:white;"
      )
        v-card-text
          v-layout(row wrap align-center)
            v-flex(xs12 sm6)
              span(style="font-size:10px;font-weight:700;color:#ACB6BE;letter-spacing:0.5px;") TAREA
              div(style="font-size:16px;font-weight:700;color:#111825;margin-top:2px;") {{ t.tarea }}
              div(v-if="t.descripcion" style="font-size:13px;color:#515978;margin-top:2px;") {{ t.descripcion }}
            v-flex(xs12 sm6 style="display:flex;justify-content:flex-end;align-items:center;flex-wrap:wrap;gap:8px;")
              span(
                :style="statusStyle(t.estatus)"
                style="padding:4px 12px;border-radius:20px;font-size:12px;font-weight:700;"
              ) {{ t.estatus }}

          v-divider(style="margin:10px 0;")

          v-layout(row wrap)
            v-flex(xs12 sm3)
              span(style="font-size:10px;font-weight:600;color:#ACB6BE;") VENDEDOR
              div(style="font-size:13px;color:#515978;") {{ t.ven_des || t.co_ven }}
            v-flex(xs12 sm3 v-if="t.cli_des")
              span(style="font-size:10px;font-weight:600;color:#ACB6BE;") CLIENTE
              div(style="font-size:13px;color:#515978;") {{ t.cli_des }}
            v-flex(xs12 sm3)
              span(style="font-size:10px;font-weight:600;color:#ACB6BE;") FECHAS
              div(style="font-size:13px;color:#515978;") {{ formatDate(t.fecha_desde) }} — {{ formatDate(t.fecha_hasta) }}
            v-flex(xs12 sm3 v-if="t.estatus === 'Hecha' && t.fecha_cierre")
              span(style="font-size:10px;font-weight:600;color:#ACB6BE;") FECHA CIERRE
              div(style="font-size:13px;color:#515978;") {{ formatDate(t.fecha_cierre) }}

          div(v-if="t.estatus === 'Hecha'" style="margin-top:10px;")
            v-divider(style="margin-bottom:10px;")
            v-layout(row wrap)
              v-flex(xs12 sm6 v-if="t.comentario")
                span(style="font-size:10px;font-weight:600;color:#ACB6BE;") COMENTARIO
                div(
                  style="font-size:13px;color:#33691E;background:#F1F8E9;padding:8px 12px;border-radius:8px;margin-top:4px;"
                ) {{ t.comentario }}
              v-flex(xs12 sm6 v-if="t.foto" style="display:flex;flex-direction:column;")
                span(style="font-size:10px;font-weight:600;color:#ACB6BE;") FOTO
                div(style="margin-top:6px;")
                  img(
                    :src="baseUrl + t.foto"
                    style="width:90px;height:90px;object-fit:cover;border-radius:8px;cursor:pointer;border:1px solid #EFEFEF;"
                    @click="abrirFoto(baseUrl + t.foto)"
                  )

    v-dialog(v-model="dialogFoto" max-width="900px")
      v-card(flat style="background:black;")
        v-card-text(style="padding:8px;text-align:center;position:relative;")
          v-btn(icon absolute top right style="top:4px;right:4px;" @click="dialogFoto=false")
            v-icon(color="white") close
          img(:src="fotoActiva" style="max-width:100%;max-height:85vh;object-fit:contain;border-radius:4px;")
</template>

<script>
import methods from "@/services/methods";
import { server, port } from "@/services/environment";

export default {
  name: "Tareas",
  data() {
    return {
      tareas: [],
      filtroVen: null,
      filtroCli: null,
      filtroEstatus: null,
      busqueda: "",
      loading: false,
      dialogFoto: false,
      fotoActiva: "",
      estatusItems: ["Pendiente", "Hecha"],
      baseUrl: `${server}:${port}/`,
    };
  },
  computed: {
    vendedoresItems() {
      const uniq = {};
      this.tareas.forEach(t => {
        if (t.co_ven) uniq[t.co_ven] = t.ven_des || t.co_ven;
      });
      return Object.entries(uniq).map(([k, v]) => ({ text: v, value: k }));
    },
    clientesItems() {
      if (!this.filtroVen) return [];
      const uniq = {};
      this.tareas
        .filter(t => t.co_ven === this.filtroVen && t.cli_des)
        .forEach(t => { uniq[t.co_cli || t.cli_des] = t.cli_des; });
      return Object.entries(uniq).map(([k, v]) => ({ text: v, value: k }));
    },
    tareasFiltradas() {
      return this.tareas.filter(t => {
        if (this.filtroVen && t.co_ven !== this.filtroVen) return false;
        if (this.filtroCli && (t.co_cli || t.cli_des) !== this.filtroCli) return false;
        if (this.filtroEstatus && t.estatus !== this.filtroEstatus) return false;
        if (this.busqueda) {
          const q = this.busqueda.toLowerCase();
          const match =
            (t.tarea || "").toLowerCase().includes(q) ||
            (t.cli_des || "").toLowerCase().includes(q) ||
            (t.ven_des || "").toLowerCase().includes(q) ||
            (t.descripcion || "").toLowerCase().includes(q);
          if (!match) return false;
        }
        return true;
      });
    }
  },
  mounted() {
    this.fetchTareas();
  },
  methods: {
    onVendedorChange() {
      this.filtroCli = null;
    },
    async fetchTareas() {
      this.loading = true;
      try {
        const res = await methods.get("tarea/sup");
        this.tareas = Array.isArray(res.data) ? res.data : [];
      } catch (e) {
        console.error("Error cargando tareas:", e);
        this.tareas = [];
      }
      this.loading = false;
    },
    formatDate(d) {
      if (!d) return "—";
      try {
        return new Date(d).toLocaleDateString("es-VE", {
          day: "2-digit", month: "2-digit", year: "numeric"
        });
      } catch {
        return d;
      }
    },
    statusStyle(estatus) {
      if (estatus === "Hecha") {
        return "background:rgba(46,125,50,0.12);color:#2E7D32;";
      }
      return "background:rgba(230,126,34,0.12);color:#E67E22;";
    },
    abrirFoto(url) {
      this.fotoActiva = url;
      this.dialogFoto = true;
    }
  }
};
</script>
